import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Platformfeature() {
  return (
    <section className="platform_feature p-100 text_second_text">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="platform_img">
              <StaticImage
                src="../../../images/case-studies/truth-gpt/Mission.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={709}
                height={753}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>Mission</h2>
            <p>
              TekRevol's mission with TruthGPT was to empower users by
              delivering accurate, unbiased, and transparent information through
              an innovative chatbot interface.
            </p>
            <p>
              The integration of blockchain technology aimed to enhance
              security, while the inclusion of the 3D character, Truthie, added
              a visually appealing and engaging element to the user experience. 
            </p>
            <p>
              The mission was to create a reliable tool for information seekers,
              fact-checkers, and those desiring unbiased responses.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Platformfeature;
